import { Inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, iif, mergeMap, Observable, of, switchMap } from 'rxjs';
import { Action } from '@ngrx/store';
import { SHARED_ENVIRONMENT } from '@cp/shared/environment/environment.token';
import { Environment } from '@cp/shared/environment/environment.interface';
import {
  PayRatesActions,
  PayRatesAPIActions,
} from '../actions/pay-rates.actions';
import { DashboardHttpService } from '../../http/dashboard/dashboard-http.service';

@Injectable()
export class PayRatesEffects {
  public loadPayRates$: Observable<Action> = createEffect(() =>
    this._actions$.pipe(
      ofType(PayRatesActions.loadPayRates),
      switchMap(() =>
        iif(
          () => this._environment.featureFlags.touchless,
          this._dashboardHttpService.payRatesTouchless$,
          this._dashboardHttpService.payRates$,
        ).pipe(
          mergeMap((payRates) =>
            of(
              PayRatesAPIActions.loadedPayRatesSuccessfully({
                payRates,
              }),
            ),
          ),
          catchError((error) =>
            of(PayRatesAPIActions.loadedPayRatesUnsuccessfully({ error })),
          ),
        ),
      ),
    ),
  );

  constructor(
    private _actions$: Actions,
    private _dashboardHttpService: DashboardHttpService,
    @Inject(SHARED_ENVIRONMENT) private _environment: Environment,
  ) {}
}
